<template>
    <div
        v-if="show"
        class="row g-2 g-lg-1 p-3 align-items-center my-1 bg-white"
    >
        <div class="col-3 col-md-2 col-lg-1 mt-0">
            <child-thumbnail
                class="thumb-placeholder"
                :key="childRow.id_child"
                :hideStatusBox="true"
                :child="fullChild"
                @click-handler="$emit('toggle-presence', childRow)"
                aria-hidden="true"
            />
        </div>
        <div class="col-9 col-md-10 col-lg-11">
            <div class="row g-2 align-items-center">
                <div class="col-12 col-lg-4 mt-0">
                    <div class="lh-sm">
                        <router-link
                            :to="'/children/' + childRow.id_child"
                            class="text-decoration-none"
                        >
                            <p class="h6 mb-1 fw-semibold text-break">
                                {{ fullChild.first_name }}
                                {{ fullChild.last_name_suffix }}
                                {{ fullChild.last_name }}
                                <span class="fw-normal fs-sm">
                                    {{ getAge(fullChild.date_of_birth, false) }}
                                </span>
                            </p>
                            <p
                                v-if="school"
                                class="small mb-0"
                            >{{ school.name }}<span v-if="schoolClass">{{ ' - ' + schoolClass }}</span></p>
                        </router-link>
                    </div>
                </div>
                <section class="col-12 col-lg-3">
                    <router-link
                        :to="'/children/' + childRow.id_child + '#Toestemmingen'"
                        class="d-inline-flex flex-wrap align-items-center gap-1"
                    >
                        <icon
                            v-if="fullChild.status && fullChild.status.instruction === 'high'"
                            name="care-prio-high"
                            :fontSize="'1rem'"
                        />
                        <icon
                            v-else-if="fullChild.status && fullChild.status.instruction === 'normal'"
                            name="care-prio-normal-solid"
                            :fontSize="'1rem'"
                        />
                        <i
                            v-if="fullChild.status && fullChild.status.ill"
                            class="fa-regular fa-temperature-three-quarters text-danger"
                        ></i>
                        <i
                            v-if="fullChild.status && fullChild.status.sleep"
                            class="fa-regular fa-moon-stars text-warning"
                        ></i>
                        <i
                            v-for="(permission, index) in (fullChild.optional_fields && fullChild.optional_fields.permissions) || []"
                            :key="index"
                            :class="permission.icon.class"
                            :style="{ color: permission.icon.color || 'rgb(188, 198, 211)' }"
                        ></i>
                    </router-link>
                </section>
                <section class="col-12 col-lg-4">
                    <ul
                        v-if="childRow.planning && childRow.planning.length > 0"
                        class="list-unstyled mb-0 small"
                    >
                        <li
                            v-for="item in childRow.planning"
                            :key="item.start_time"
                            class="text-break"
                            @click="handleOpenPlanning(item)"
                        >
                            <span :class="{ 'status-deleted': (item.status && item.status === 'DELETED') }">
                                {{ $moment('2022-01-01 ' + item.start_time).format('HH:mm') }} - {{ $moment('2022-01-01 ' + item.end_time).format('HH:mm') }}
                                {{ item.group.name }}
                            </span>
                        </li>
                    </ul>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
import ChildThumbnail from '@/components/Child-Thumbnail'
import Icon from '@/components/Icon'

export default {
    name: 'child-planning-row',
    components: {ChildThumbnail, Icon},
    props: {
        childRow: {type: Object, required: true},
        fullChild: {type: Object, required: true},
        show: {type: Boolean, default: true},
        ageYears: {type: [Number, String], required: true},
        school: {type: [Object, Boolean, null], default: null},
        schoolClass: {type: [String, Boolean, null], default: null},
        allowEdit: {type: Boolean, default: false},
        dateResolved: {type: String, required: true},
        currentGroupId: {type: [Number, String, null], default: null}
    },
    emits: ['toggle-presence', 'open-planning'],
    computed: {
        ariaLabel() {
            const fn = this.fullChild.first_name || ''
            const ls = this.fullChild.last_name_suffix || ''
            const ln = this.fullChild.last_name || ''
            return `${(fn + ' ' + ls + ' ' + ln).trim()}`
        }
    },
    methods: {
        handleOpenPlanning() {
            if (!this.allowEdit) return
            this.$emit('open-planning', {currentGroupId: this.currentGroupId, date: this.dateResolved})
        }
    }
}
</script>

<style scoped>
a {
    color: #666;
}

.thumb-placeholder {
    width: 3rem;
    height: 3rem;
}

.status-deleted {
    text-decoration: line-through;
    color: #6c757d;
}

.fa,
.fa-solid, .fa-regular, .fa-light,
.icon {
    color: rgb(188, 198, 211);
    margin-right: 5px;
    margin-bottom: 5px;
}

.fs-sm {
    font-size: .875rem;
}
</style>
